import { Route, Redirect } from 'react-router-dom';
import cookie from './services/cookie/index.js';

const PrivateAdminRoute = ({ component: Component, ...rest }) => {
  const username = cookie().get("username");
  const token = cookie().get("tokenAdm");
  const role = cookie().get("role");

  const isAuthenticated = token && username && role;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/admin" />
        )
      }
    />
  );
};

export default PrivateAdminRoute;
